import { useEffect } from "react";

export default function useHeaderScroll() {
  useEffect(() => {
    const toggleScrolled = () => {
      if (window.scrollY > 100) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", toggleScrolled);
    toggleScrolled();

    return () => window.removeEventListener("scroll", toggleScrolled);
  }, []);
}
